import type { ComputedRef } from 'vue'

import { regionOrigin } from '#shared/lib/region'
import { computed } from 'vue'

import { useRegion } from '~/composables/useRegion'

// Origin для абсолютных URL (canonical, og-теги, JSON-LD) — origin региона, построенный
// от NUXT_PUBLIC_SITE_URL, а не от заголовков запроса: так он одинаков у всех запросов
// одного региона и не зависит от Host, с которым пришёл первый (кэшируемый) рендер.
// NUXT_PUBLIC_SITE_URL также используется в server/services/sitemap.ts и robots.txt.
export const useSiteOrigin = (): ComputedRef<string> => {
  const requestUrl = useRequestURL()
  const runtimeConfig = useRuntimeConfig()
  const region = useRegion()

  return computed<string>(() => {
    const raw = (runtimeConfig.public.siteUrl as string | undefined)?.trim() ?? ''
    if (raw.length === 0) {
      return requestUrl.origin
    }

    try {
      return regionOrigin(region.value, raw)
    } catch {
      return requestUrl.origin
    }
  })
}
